<template>
  <div class="display-input">
    <div class="form-group row">
      <template v-if="options.plainText">
        <label :for="options.name" class="col-sm-3 col-form-label">
          {{ options.label }}
        </label>
        <div class="col-sm-9 display-val">
          {{ value }}
        </div>
      </template>
      <template v-else>
        <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
          {{ options.label }}
        </label>
        <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
          <input class="form-control" type="text" :value="options.value" readonly/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import { toDollarAmount } from '@/util/filters'

export default {
  name: 'DisplayInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object,
      default () {
        return {
          plainText: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  methods: {
    validate () {
      return true
    },
    calJumpQueueCost (val) {
      if (this.options.name === 'jumpQueueCost') {
        if (val) {
          this.options.value = toDollarAmount(this.options.quoteFullCost * 0.2)
        } else {
          this.options.value = toDollarAmount(0)
        }
      } else if (this.options.name === 'fullCostwithJQ') {
        if (val) {
          this.options.value = toDollarAmount(this.options.quoteFullCost + this.options.quoteFullCost * 0.2)
        } else {
          this.options.value = toDollarAmount(this.options.quoteFullCost)
        }
      }
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        switch (name) {
          case 'queueJumped':
            if (val || val === false) {
              this.calJumpQueueCost(val)
            }
            break
          case 'pBGrCheaperQuoteCost':
            this.options.value = toDollarAmount(val - val / 10)
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DisplayInput.vue